import { render, staticRenderFns } from "./UploadSimple.vue?vue&type=template&id=bf2c54fe&scoped=true&"
import script from "./UploadSimple.vue?vue&type=script&lang=js&"
export * from "./UploadSimple.vue?vue&type=script&lang=js&"
import style0 from "./UploadSimple.vue?vue&type=style&index=0&id=bf2c54fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2c54fe",
  null
  
)

export default component.exports